
import React, { useCallback, useContext, useMemo } from "react";
import { HeaderA } from "components/headers";
import lang from "translations";
import { Path } from "paths";
import { VenueContext } from "contexts";
import { useApi, useMount, useFilter } from "hooks";
import { searchSection } from "apis";
import { ButtonLink, DataTable, Pill } from "components/commons";
import { PillType } from "enums";
import { prettifyVoucherStatus } from "services";
import columns from "./columns";
import { section } from "mappers";
import { ModuleWrapper } from "components/fragments";

const SectionList = () => {
  const { venue } = useContext(VenueContext);
  const { venueId } = venue;

  const {
    request,
    loading = true,
    error,
    result = { data: [] },
    mappedData,
  } = useApi({
    api: searchSection,
    isArray: true,
    mapper: section,
    returnMappedData: true,
  });

  const defaultFilter = {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
  };
  const { modifyFilters, filterState } = useFilter(defaultFilter, defaultFilter);

  useMount(() => {
    request(filterState);
  });

  const fetchUpdateStore = useCallback(
    async (requestState) => {
      request(requestState);
    },
    [request]
  );

  const renderData = useMemo(() => {
    return mappedData.map(({ name, zoneId, locationName, isActive }) => {
      return {
        name: <ButtonLink path={Path.SECTION_ID(zoneId)}>{name}</ButtonLink>,
        locationName: locationName ?? "-",
        isActive: (
          <Pill
            type={isActive ? PillType.Green : PillType.Opaque}
            size="text-xs"
          >
            {isActive ? prettifyVoucherStatus("ACTIVE") : prettifyVoucherStatus("INACTIVE")}
          </Pill>
        ),
      };
    });
  }, [mappedData]);

  return (
    <ModuleWrapper>
      <HeaderA
        title={lang.sectionList}
        description={lang.manageSection}
        button={{
          path: Path.SECTION_CREATE,
          text: lang.createSection,
        }}
        className="mb-md"
      />
      <text>{result.metadata?.total} {lang.searchResults}</text>
      <DataTable
        page={filterState.page}
        pageSize={filterState.pageSize}
        onChangePage={modifyFilters}
        fetchList={fetchUpdateStore}
        total={result.data?.total}
        renderEmpty={{
          image: "https://pouch-inventory.s3.us-east-2.amazonaws.com/landing-image/no-resource-types.png",
          title: lang.createSectionToManage,
        }}
        loading={loading}
        columns={columns}
        data={renderData}
        error={error}
      />
    </ModuleWrapper>
  );
};

export default SectionList;